<template>
  <div id="history-adding">
    <b-container fluid>
      <b-row>
        <b-col>
          <b-breadcrumb>
            <b-breadcrumb-item
              v-if="status.animal"
              text="รายชื่อสัตว์"
              @click="goHistoryPage(null)"
            />
            <b-breadcrumb-item
              v-if="status.customer"
              text="รายชื่อสถานพยาบาล"
              @click="goHistoryPage(null)"
            />
            <b-breadcrumb-item
              v-if="status.addingCustomer"
              text="เพิ่มประวัติสถานพยาบาล"
              active
            />
            <b-breadcrumb-item
              v-if="!status.addingCustomer"
              text="แก้ไขประวัติลูกค้า"
              active
            />
          </b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div v-if="status.addingCustomer" class="topic">
            {{
              status.addingCustomer
                ? "เพิ่มประวัติสถานพยาบาล"
                : "แก้ไขประวัติสถานพยาบาล"
            }}
          </div>
        </b-col>
      </b-row>
      <template v-if="!status.addingCustomer">
        <b-row class="justify-content-md-center">
          <b-col cols="auto">
            <table class="table">
              <tr>
                <td>สร้างโดย</td>
                <td>{{ data.created_by ? data.created_by.name : "-" }}</td>
                <td>{{ data.created_at }}</td>
              </tr>
              <tr>
                <td>แก้ไขโดย</td>
                <td>{{ data.updated_by ? data.updated_by.name : "-" }}</td>
                <td>{{ data.updated_at }}</td>
              </tr>
            </table>
          </b-col>
        </b-row>
      </template>
      <b-row class="justify-content-md-center">
        <b-col col xl="10">
          <b-form novalidate @input="changeValueForm">
            <b-container fluid>
              <b-row>
                <b-col class="left mt-2">
                  <b>ข้อมูลทั่วไป</b>
                </b-col>
              </b-row>
              <div class="form-group-wrapper p-xl-4 p-1">
                <b-row class="left mt-2">
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="4"
                    xl="3"
                  >
                    <label for="hospital-input">ชื่อสถานพยาบาล</label>
                    <img
                      alt="required-field"
                      src="../../assets/asterisk.svg"
                      class="star"
                    />
                    <b-form-input
                      id="hospital-input"
                      v-model="data.name"
                      :class="{
                        invalidText: isInvalidName,
                      }"
                      type="text"
                      class="form-control"
                      required
                      :disabled="!permission.canCreate || !permission.canEdit"
                    />
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="4"
                    xl="3"
                  >
                    <label for="billing-name-input" l>ชื่อสำหรับออกบิล</label>
                    <img
                      alt="required-field"
                      src="../../assets/asterisk.svg"
                      class="star"
                    />
                    <b-form-input
                      id="billing-name-input"
                      v-model="data.billing_name"
                      type="text"
                      class="form-control"
                      :disabled="!permission.canCreate || !permission.canEdit"
                    />
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="4"
                    xl="2"
                  >
                    <label for="tax-id-input">Tax ID</label>
                    <b-form-input
                      id="tax-id-input"
                      v-model="data.tax_id"
                      type="text"
                      class="form-control"
                      :disabled="!permission.canCreate || !permission.canEdit"
                    />
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="4"
                    xl="2"
                  >
                    <label for="hospital-code-input">รหัส</label>
                    <b-form-input
                      id="hospital-code-input"
                      v-model="data.code"
                      type="text"
                      class="form-control"
                      disabled
                    />
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="4"
                    xl="2"
                  >
                    <label for="corporation-select-input">Corporation</label>
                    <img
                      alt="required-field"
                      src="../../assets/asterisk.svg"
                      class="star"
                    />
                    <multiselect
                      id="corporation-select-input"
                      v-model="data.corporation"
                      style="min-width: 200px;"
                      :class="{ invalid: isInvalidCorp }"
                      :options="corporation"
                      label="name"
                      track-by="id"
                      placeholder="เลือก Corporation"
                      :show-labels="false"
                      :allow-empty="false"
                      :disabled="!permission.canCreate || !permission.canEdit"
                    />
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="4"
                    xl="3"
                  >
                    <label for="corporation-select-input">เส้นทางวิ่ง</label>
                    <img
                      alt="required-field"
                      src="../../assets/asterisk.svg"
                      class="star"
                    />
                    <multiselect
                      id="direction-select-input"
                      v-model="data.direction_info.direction"
                      style="min-width: 200px;"
                      :class="{ invalid: isInvalid }"
                      :options="direction"
                      label="direction"
                      track-by="id"
                      :show-labels="false"
                      placeholder="เลือกเส้นทาง"
                      :allow-empty="false"
                      :disabled="!permission.canCreate || !permission.canEdit"
                      @close="setCodeFromDirection()"
                    />
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="5"
                    xl="5"
                  >
                    <label for="branch-input">สาขา</label>
                    <b-form-input
                      id="branch-input"
                      v-model="data.branch"
                      type="text"
                      class="form-control"
                      :disabled="!permission.canCreate || !permission.canEdit"
                    />
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="4"
                    xl="2"
                  >
                    <label for="customer-type-input">ประเภทลูกค้า</label>
                    <multiselect
                      id="customer-type-input"
                      v-model="data.customer_type"
                      style="min-width: 200px;"
                      :options="customerType"
                      label="type_name"
                      track-by="id"
                      select-label
                      deselect-label="✖"
                      selected-label
                      placeholder="เลือกประเภท"
                      :disabled="!permission.canCreate || !permission.canEdit"
                    />
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="4"
                    xl="2"
                  >
                    <label for="payment-method-input">การชำระเงิน</label>
                    <multiselect
                      id="payment-method-input"
                      v-model="data.credit_type"
                      style="min-width: 200px;"
                      :options="creditType"
                      label="type_name"
                      track-by="id"
                      select-label
                      deselect-label="✖"
                      selected-label
                      placeholder="เลือกการชำระเงิน"
                      :disabled="!permission.canCreate || !permission.canEdit"
                    />
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="2"
                    xl="1"
                  >
                    <label for="fast-input">ด่วนพิเศษ</label>
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        <b-form-checkbox
                          id="emergency-checkbox"
                          v-model="data.urgency_hospital_type"
                          :value="
                            urgencyHospitalType.find(
                              (urgen) => urgen.type_name === 'ด่วน'
                            )
                          "
                          :unchecked-value="
                            urgencyHospitalType.find(
                              (urgen) => urgen.type_name === 'ปกติ'
                            )
                          "
                          :disabled="
                            !permission.canCreate || !permission.canEdit
                          "
                          >ด่วน</b-form-checkbox
                        >
                      </b-input-group-prepend>
                    </b-input-group>
                  </b-col>
                  <b-col
                    class="mt-1"
                    col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="11"
                    xl="11"
                  >
                    <label for="note-input">Note</label>
                    <b-form-input
                      id="note-input"
                      v-model="data.note"
                      :disabled="!permission.canCreate || !permission.canEdit"
                      type="text"
                      class="form-control"
                    />
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt-5">
                <b-col class="left">
                  <b>เวลาเข้า</b>
                  <img
                    alt="required-field"
                    src="../../assets/asterisk.svg"
                    class="star"
                  />
                </b-col>
              </b-row>
              <div class="form-group-wrapper">
                <b-row>
                  <b-col class="m-2" xl="3">
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        <b-form-checkbox
                          id="morning-checkbox"
                          v-model="checkMorningInput"
                          :disabled="
                            !permission.canCreate || !permission.canEdit
                          "
                          >เช้า</b-form-checkbox
                        >
                      </b-input-group-prepend>
                      <flat-pickr
                        id="morning-select-date-input"
                        v-model="data.direction_info.morning"
                        :class="{
                          'form-control': true,
                          'invalid-time':
                            !data.direction_info.morning && checkMorningInput,
                        }"
                        :config="timePickerConfig"
                        placeholder="Select Time"
                        required
                        :disabled="
                          !checkMorningInput &&
                            (!permission.canCreate || !permission.canEdit)
                        "
                      />
                    </b-input-group>
                  </b-col>
                  <b-col class="m-2" xl="3">
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        <b-form-checkbox
                          id="afternoon-checkbox"
                          v-model="checkAfternoonInput"
                          :disabled="
                            !permission.canCreate || !permission.canEdit
                          "
                          >บ่าย</b-form-checkbox
                        >
                      </b-input-group-prepend>
                      <flat-pickr
                        id="afternoon-select-date-input"
                        v-model="data.direction_info.afternoon"
                        :class="{
                          'form-control': true,
                          'invalid-time':
                            !data.direction_info.afternoon &&
                            checkAfternoonInput,
                        }"
                        :config="timePickerConfig"
                        placeholder="Select Time"
                        required
                        :disabled="
                          !checkAfternoonInput &&
                            (!permission.canCreate || !permission.canEdit)
                        "
                      />
                    </b-input-group>
                  </b-col>
                  <b-col class="m-2" xl="3">
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        <b-form-checkbox
                          id="evening-checkbox"
                          v-model="checkEveningInput"
                          :disabled="
                            !permission.canCreate || !permission.canEdit
                          "
                          >เย็น</b-form-checkbox
                        >
                      </b-input-group-prepend>
                      <flat-pickr
                        id="evening-select-date-input"
                        v-model="data.direction_info.evening"
                        :class="{
                          'form-control': true,
                          'invalid-time':
                            !data.direction_info.evening && checkEveningInput,
                        }"
                        :config="timePickerConfig"
                        placeholder="Select Time"
                        required
                        :disabled="
                          !checkEveningInput &&
                            (!permission.canCreate || !permission.canEdit)
                        "
                      />
                    </b-input-group>
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt-5">
                <b-col class="left">
                  <b>ช่องทางการติดต่อ</b>
                </b-col>
              </b-row>
              <div class="form-group-wrapper">
                <b-row class="left mt-2 px-2">
                  <b-col class="my-2" cols="12" xs="12" md="4" xl="3">
                    <label for="address-insert-input">ที่อยู่</label>
                    <img
                      alt="required-field"
                      src="../../assets/asterisk.svg"
                      class="star"
                    />
                    <b-form-input
                      id="address-insert-input"
                      v-model="addressInput"
                      type="text"
                      :class="{
                        invalidText: isInvalidAddress,
                        'form-control': true,
                      }"
                    />
                  </b-col>
                  <b-col class="my-2" cols="12" xs="12" md="4" xl="2">
                    <label for="province-insert-input">จังหวัด</label>
                    <img
                      alt="required-field"
                      src="../../assets/asterisk.svg"
                      class="star"
                    />
                    <multiselect
                      id="province-insert-input"
                      v-model="provinceInput"
                      style="min-width: 200px;"
                      select-label
                      deselect-label="✖"
                      selected-label
                      :class="{
                        invalid: isInvalidAddress,
                      }"
                      :options="lstProvinces"
                      @close="
                        setDistricts(objProvinces[provinceInput])
                          .then(setOptions)
                          .then(resetDistrict)
                          .then(resetSubDistrict)
                      "
                    />
                  </b-col>
                  <b-col class="my-2" cols="12" xs="12" md="4" xl="2">
                    <label for="district-insert-input">เขต/อำเภอ</label>
                    <img
                      alt="required-field"
                      src="../../assets/asterisk.svg"
                      class="star"
                    />
                    <multiselect
                      id="district-insert-input"
                      v-model="districtInput"
                      style="min-width: 200px;"
                      select-label
                      deselect-label="✖"
                      selected-label
                      :class="{
                        invalid: isInvalidAddress,
                      }"
                      :options="lstDistricts"
                      @close="
                        setSubDistricts(objDistricts[districtInput])
                          .then(setOptions)
                          .then(resetSubDistrict)
                      "
                    />
                  </b-col>
                  <b-col class="my-2" cols="12" xs="12" md="4" xl="2">
                    <label for="sub-district-insert-input">แขวง/ตำบล</label>
                    <img
                      alt="required-field"
                      src="../../assets/asterisk.svg"
                      class="star"
                    />
                    <multiselect
                      id="sub-district-insert-input"
                      v-model="subDistrictInput"
                      style="min-width: 200px;"
                      select-label
                      deselect-label="✖"
                      selected-label
                      :class="{
                        invalid: isInvalidAddress,
                      }"
                      :options="lstSubDistricts"
                    />
                  </b-col>
                  <b-col class="my-2" cols="12" xs="12" md="4" xl="2">
                    <label for="postal-code-insert-input">รหัสไปรษณีย์</label>
                    <img
                      alt="required-field"
                      src="../../assets/asterisk.svg"
                      class="star"
                    />
                    <b-form-input
                      id="postal-code-insert-input"
                      v-model="postCodeInput"
                      :class="{
                        invalidText: isInvalidAddress,
                      }"
                      type="text"
                    />
                  </b-col>
                  <b-col
                    class="my-2 text-center"
                    cols="12"
                    xs="12"
                    md="12"
                    xl="1"
                    align-self="end"
                  >
                    <b-button
                      class="add-btn"
                      :disabled="!permission.canCreate || !permission.canEdit"
                      @click="addAddress"
                      >เพิ่ม</b-button
                    >
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <multi-value-table
                      type="address"
                      :items="data.addresses"
                      :del-handler="delAddress"
                    />
                  </b-col>
                </b-row>
                <b-row class="left mt-2 px-2">
                  <b-col col xl="6" sm="12" cols="12">
                    <b-row>
                      <b-col col cols="12" sm="12" xl="10">
                        <label for="phone-insert-input">เบอร์โทร</label>
                        <img
                          alt="required-field"
                          src="../../assets/asterisk.svg"
                          class="star"
                        />
                        <b-form-input
                          id="phone-insert-input"
                          v-model="phoneInput"
                          :class="{
                            invalidText: isInvalidPhones,
                          }"
                          type="text"
                          class="form-control"
                        />
                      </b-col>
                      <b-col
                        col
                        cols="12"
                        sm="12"
                        xl="2"
                        align-self="end"
                        class="text-center my-2"
                      >
                        <b-button
                          class="add-btn"
                          :disabled="
                            !permission.canCreate || !permission.canEdit
                          "
                          @click="addPhone"
                          >เพิ่ม</b-button
                        >
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <multi-value-table
                          type="phone"
                          :items="data.phones"
                          :del-handler="delPhone"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <!--                                    <b-col col xl="6" sm="12" cols="12">-->
                  <!--                                        <b-row>-->
                  <!--                                            <b-col-->
                  <!--                                                col-->
                  <!--                                                cols="12"-->
                  <!--                                                sm="12"-->
                  <!--                                                xl="10"-->
                  <!--                                            >-->
                  <!--                                                <label>Line ID</label>-->
                  <!--                                                <b-form-input-->
                  <!--                                                    type="text"-->
                  <!--                                                    class="form-control"-->
                  <!--                                                    v-model="lineIdInput"-->
                  <!--                                                />-->
                  <!--                                            </b-col>-->
                  <!--                                            <b-col-->
                  <!--                                                col-->
                  <!--                                                cols="12"-->
                  <!--                                                sm="12"-->
                  <!--                                                xl="2"-->
                  <!--                                                align-self="end"-->
                  <!--                                                class="text-center my-2"-->
                  <!--                                            >-->
                  <!--                                                <b-button-->
                  <!--                                                    class="add-btn"-->
                  <!--                                                    @click="addLineId"-->
                  <!--                                                >-->
                  <!--                                                    <fa-icon-->
                  <!--                                                        :icon="['fas', 'plus']"-->
                  <!--                                                        class="icon"-->
                  <!--                                                    />-->
                  <!--                                                </b-button>-->
                  <!--                                            </b-col>-->
                  <!--                                        </b-row>-->
                  <!--                                        <b-row>-->
                  <!--                                            <b-col>-->
                  <!--                                                <multi-value-table-->
                  <!--                                                    type="line"-->
                  <!--                                                    :items="data.lineIds"-->
                  <!--                                                    :del-handler="delLine"-->
                  <!--                                                />-->
                  <!--                                            </b-col>-->
                  <!--                                        </b-row>-->
                  <!--                                    </b-col>-->
                  <b-col col xl="6" sm="12" cols="12">
                    <b-row>
                      <b-col col cols="12" sm="12" xl="10">
                        <label for="fax-insert-input">Fax</label>
                        <b-form-input
                          id="fax-insert-input"
                          v-model="faxInput"
                          type="text"
                          class="form-control"
                        />
                      </b-col>
                      <b-col
                        col
                        cols="12"
                        sm="12"
                        xl="2"
                        align-self="end"
                        class="text-center my-2"
                      >
                        <b-button
                          class="add-btn"
                          :disabled="
                            !permission.canCreate || !permission.canEdit
                          "
                          @click="addFax"
                          >เพิ่ม</b-button
                        >
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <multi-value-table
                          type="fax"
                          :items="data.faxs"
                          :del-handler="delFax"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col col xl="6" sm="12" cols="12">
                    <b-row>
                      <b-col col cols="12" sm="12" xl="10">
                        <label for="email-insert-input">E-mail</label>
                        <b-form-input
                          id="email-insert-input"
                          v-model="emailInput"
                          type="text"
                          class="form-control"
                        />
                      </b-col>
                      <b-col
                        col
                        cols="12"
                        sm="12"
                        xl="2"
                        align-self="end"
                        class="text-center my-2"
                      >
                        <b-button
                          class="add-btn"
                          :disabled="
                            !permission.canCreate || !permission.canEdit
                          "
                          @click="addEmail"
                          >เพิ่ม</b-button
                        >
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <multi-value-table
                          type="email"
                          :items="data.emails"
                          :del-handler="delEmail"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt-5">
                <b-col class="left">
                  <b>วิธีส่งผล</b>
                  <img
                    alt="required-field"
                    src="../../assets/asterisk.svg"
                    class="star"
                  />
                </b-col>
              </b-row>
              <div
                :class="{
                  'form-group-wrapper': true,
                  invalidText: isInvalidContact,
                }"
              >
                <b-row class="p-2 text-left">
                  <b-col>
                    <b-form-checkbox-group v-model="contact">
                      <b-form-checkbox
                        v-for="(contactType, index) in contactTypes"
                        :id="contactType.type_name"
                        :key="index"
                        :value="contactType.type_name"
                      >
                        <!-- :disabled="checkDisableSendGroup(contactType.type_name) || (!permission.canCreate || !permission.canEdit)" -->
                        {{ contactType.type_name | convertContactTypeName }}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt-5">
                <b-col class="left">
                  <b>เลือกค่าเริ่มต้นประเภทไฟล์การส่ง</b>
                </b-col>
              </b-row>
              <div
                :class="{
                  'form-group-wrapper': true,
                }"
              >
                <b-row class="p2 text-left">
                  <b-col class="col-12">
                    <table
                      hover
                      small
                      caption-top
                      responsive
                      class="table"
                      style="width:100%;"
                    >
                      <thead>
                        <tr>
                          <th>ประเภทการส่ง</th>
                          <th>ประเภทไฟล์</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="contactFile in contactTypeFile">
                          <tr :key="contactFile.id">
                            <td>
                              {{
                                contactFile.type_name | convertContactTypeName
                              }}
                            </td>
                            <td>
                              <b-form-checkbox-group
                                id="contact-type-file"
                                v-model="
                                  contactTypeFileSelected[contactFile.type_name]
                                "
                                name="contact-type-file"
                              >
                                <template
                                  v-for="method in contactFile.share_methods"
                                >
                                  <b-form-checkbox
                                    :key="method"
                                    :value="method"
                                    >{{ method }}</b-form-checkbox
                                  >
                                </template>
                              </b-form-checkbox-group>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>

              <b-row class="my-2 offset-md-8 col-md-4">
                <b-col class="p-2">
                  <b-button
                    class="btn-secondary w-100"
                    @click="changeAndGo(null)"
                    >ยกเลิก</b-button
                  >
                </b-col>
                <b-col class="p-2">
                  <b-button
                    :disabled="!permission.canCreate || !permission.canEdit"
                    class="btn-success w-100"
                    @click="changeAndGo(data)"
                    >บันทึก</b-button
                  >
                </b-col>
              </b-row>
            </b-container>
          </b-form>
        </b-col>
      </b-row>
      <b-row v-if="!status.addingCustomer" class="justify-content-md-center">
        <b-col col xl="10">
          <b-row>
            <b-col cols="auto">
              <label>
                <input
                  v-model="filter.pet_name"
                  type="search"
                  class="form-control"
                  placeholder="ชื่อสัตว์"
                  style="min-width: 150px;"
                  @input="filter.pet_name === '' ? filters(filter) : null"
                  @keyup.enter="filters(filter)"
                />
              </label>
            </b-col>
          </b-row>
          <b-row class="justify-content-end">
            <b-col class="col-12">
              <b-table
                striped
                responsive-a
                hover
                :items="animals.data"
                :fields="fields"
              >
                <template slot="no" slot-scope="data">
                  {{ data.index + animals.from }}
                </template>
                <template slot="species" slot-scope="data">
                  {{ data.item.species.species_name }}
                </template>
                <!-- A virtual composite column -->
                <template slot="วันเวลาอัพเดทล่าสุด" slot-scope="data">
                  {{ moment(data.item.updated_at) }}
                </template>
                <template slot="ชื่อสัตว์" slot-scope="data">
                  <a
                    style="cursor:pointer;"
                    @click="
                      setAnimalData(data.item.id) &&
                        setCustomerData(data.item.hospital_id).then(
                          goHistoryAnimalAdding
                        )
                    "
                  >
                    <u>{{ data.item.name }}</u>
                  </a>
                </template>
              </b-table>
              <b-pagination
                v-model="animals.current_page"
                size="md"
                :total-rows="animals.total"
                :per-page="animals.per_page"
                @input="getDataPerPage(animals.current_page)"
              />
            </b-col>
            <b-col class="col-auto">
              <b-button variant="success" @click="goAdd"
                >เพิ่มข้อมูลสัตว์</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment-timezone";
import MultiValueTable from "../../components/History/MultiValueTable";
import Swal from "sweetalert2";

export default {
  components: {
    MultiValueTable,
  },
  data() {
    return {
      existsDirectionId: null,
      existsCode: null,
      contactTypeFileSelected: {},
      confirm: false,
      contact: [],
      lstProvinces: [],
      lstDistricts: [],
      lstSubDistricts: [],
      lstContactTypes: [],
      objProvinces: [],
      objDistricts: [],
      objSubDistricts: [],
      objContactTypes: [],
      checked: [],
      time: null,
      // delivery: [],
      checkMorningInput: false,
      checkAfternoonInput: false,
      checkEveningInput: false,
      windowWidth: 0,
      addressInput: "",
      provinceInput: "",
      districtInput: "",
      subDistrictInput: "",
      postCodeInput: "",
      phoneInput: "",
      lineIdInput: "",
      faxInput: "",
      emailInput: "",
      permission: {
        canCreate: false,
        canEdit: false,
      },
      fields: [
        // "-",
        "no",
        // A column that needs custom formatting
        { key: "an", label: "AN" },
        // A regular column
        "ชื่อสัตว์",
        // A regular column
        { key: "hn", label: "HN" },
        { key: "species", label: "Species" },
        // A virtual column made up from two fields
        { key: "gender.gender_name", label: "Gender" },
        "วันเวลาอัพเดทล่าสุด",
        // "ข้อมูลการตรวจ"
      ],
      items: [],
      filter: {
        page_no: "1",
        direction: null,
        hospital: null,
        species_id: null,
        gender: null,
        owner_name: null,
        pet_name: null,
        hn: null,
        dateOne: "",
        dateTwo: "",
      },
      timePickerConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
      },
    };
  },
  watch: {
    contactTypeFileSelected(val) {},
    "data.corporation"() {
      // console.log(this.data.corporation);
    },
    contact: function() {
      this.initializContactTypeFile();
      // this.$store.state.isEditing = true
    },
    "data.phone"() {
      if (this.data.phone == "") {
        this.contact.forEach((element) => {
          if (element == "phone") {
            this.contact.splice(this.contact.indexOf(element), 1);
            // console.log(this.contact);
          }
        });
      }
    },
    "data.email"() {
      // console.log("email");
      if (this.data.email == "") {
        this.contact.forEach((element) => {
          if (element == "email") {
            this.contact.splice(this.contact.indexOf(element), 1);
            // console.log(this.contact);
          }
        });
      }
    },
    "data.line_id"() {
      // console.log("line");
      if (this.data.line_id == "") {
        this.contact.forEach((element) => {
          if (element == "line_id") {
            this.contact.splice(this.contact.indexOf(element), 1);
            // console.log(this.contact);
          }
        });
      }
    },
    "data.fax"() {
      // console.log("faxx");
      if (this.data.fax == "") {
        this.contact.forEach((element) => {
          if (element == "fax") {
            this.contact.splice(this.contact.indexOf(element), 1);
            // console.log(this.contact);
          }
        });
      }
    },
  },
  mounted() {
    this.$store.state.isLoading = true;
    this.clearDistricts();
    this.clearSubDistricts();
    this.setAnimalList();
    this.$store.state.isLoading = false;
    this.filter.hospital = this.data;
  },
  async created() {
    this.$store.state.isLoading = true;
    if (this.data.direction_info.direction) {
      if (this.data.direction_info.direction.id) {
        this.existsDirectionId = this.data.direction_info.direction.id;
        this.existsCode = this.data.code;
      }
    }
    await this.setDirection();
    await this.setCustomerType();
    await this.setCreditType();
    await this.setUrgencyHospitalType();
    // await this.setStatus();
    await this.setCorporations();
    // await this.setContactType(this.data.contact_types);
    await this.setProvinces();
    // await this.setDistricts(this.data.province_code);
    // await this.setSubDistricts(this.data.district_code);
    let corporation_id = this.data.corporation
      ? this.data.corporation.id
      : null;
    await this.setCorporation(corporation_id);
    await this.setOptions();
    await this.setContactTypes();

    this.checkMorningInput = !!this.data.direction_info.morning;
    this.checkAfternoonInput = !!this.data.direction_info.afternoon;
    this.checkEveningInput = !!this.data.direction_info.evening;

    this.permission.canCreate = await this.checkPermission({
      type: "customer_history",
      mod: "can_create",
    });
    this.permission.canEdit = await this.checkPermission({
      type: "customer_history",
      mod: "can_edit",
    });

    // console.log(this.data.contact_types)
    this.contact = this.data.contact_types.map((contactType) => contactType);
    await this.initializContactTypeFile();
    this.data.contact_types_detail.forEach((contact) => {
      this.contactTypeFileSelected[contact.type_name] = contact.default_types;
    });

    this.$forceUpdate();

    // this.setWindowWidth();
    // window.addEventListener("resize", this.setWindowWidth);
    this.$store.state.isLoading = false;
  },
  computed: {
    ...mapGetters({
      data: "Hospital/getData",
      animals: "Animal/getDataFromFilter",
      provinces: "Address/getProvinces",
      districts: "Address/getDistricts",
      subDistricts: "Address/getSubDistricts",
      contactTypes: "ContactType/getAll",
      status: "History/getStatus",
      direction: "Direction/getAll",
      customerType: "CustomerType/getAll",
      creditType: "CreditType/getAll",
      urgencyHospitalType: "UrgencyHospitalType/getAll",
      corporation: "Corporation/getAll",
      // setAnimalData: "Animal/setData",
    }),
    contactTypeFile() {
      if (this.contact) {
        return this.contactTypes.filter((contactType) =>
          this.contact.includes(contactType.type_name)
        );
      } else {
        return [];
      }
    },
    ...mapState({
      isEditing: "isEditing",
    }),
    isLog() {
      return this.windowWidth;
    },
    isInvalid() {
      return this.data.direction_info.direction == null && this.confirm;
    },
    isInvalidCorp() {
      return this.data.corporation == null && this.confirm;
    },
    isInvalidName() {
      return this.data.name == "" && this.confirm;
    },
    isInvalidAddress() {
      return this.data.addresses.length <= 0 && this.confirm;
    },
    isInvalidContact() {
      return this.contact.length <= 0 && this.confirm;
    },
    isInvalidPhones() {
      return this.data.phones.length <= 0 && this.confirm;
    },
    isInvalidMorning() {
      return this.data.direction_info.morning === "" && this.confirm;
    },
    isInvalidAfternoon() {
      return this.data.direction_info.afternoon === "" && this.confirm;
    },
    isInvalidEvening() {
      return this.data.direction_info.evening === "" && this.confirm;
    },
    checkMorning() {
      if (this.checkMorningInput) {
        return !this.isInvalidMorning;
      } else {
        return true;
      }
    },
    checkAfternoon() {
      if (this.checkAfternoonInput) {
        return !this.isInvalidAfternoon;
      } else {
        return true;
      }
    },
    checkEvening() {
      if (this.checkEveningInput) {
        return !this.isInvalidEvening;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapActions({
      updateData: "Hospital/updateData",
      setDistricts: "Address/setDistricts",
      setSubDistricts: "Address/setSubDistricts",
      setProvinces: "Address/setProvinces",
      clearDistricts: "Address/clearDistricts",
      clearSubDistricts: "Address/clearSubDistricts",
      setContactTypes: "ContactType/setAll",
      // setCustomerData: "Hospital/getAll",
      setAnimalData: "Animal/setData",
      changeStatus: "History/changeStatus",
      // filterAnimal: "Animal/filterData",
      setDirection: "Direction/setAll",
      setCreditType: "CreditType/setAll",
      setCustomerType: "CustomerType/setAll",
      setUrgencyHospitalType: "UrgencyHospitalType/setAll",
      setStatus: "Status/setAll",
      filterAnimal: "Animal/filterData",
      setCorporations: "Corporation/setAll",
      checkPermission: "Order/checkPermission",
      setAdding: "History/setAdding",
      setData: "History/setData",
      setCustomerData: "Hospital/setData",
      genCodeHospital: "Hospital/genCodeHospital",
    }),
    initializContactTypeFile() {
      const contactTypeFileKey = Object.keys(this.contactTypeFileSelected);
      const nonContactTypeFileKey = contactTypeFileKey.filter(
        (key) => !this.contact.includes(key)
      );
      const newContactTypeFileKey = contactTypeFileKey.filter((key) =>
        this.contact.includes(key)
      );

      newContactTypeFileKey.forEach((key) => {
        this.contactTypeFileSelected[key] = [];
      });
      nonContactTypeFileKey.forEach(
        (key) => delete this.contactTypeFileSelected[key]
      );
    },
    changeValueForm() {
      this.$store.state.isEditing = true;
    },
    getDataPerPage(pageNo) {
      this.filter.page_no = pageNo;
      this.filters(this.filter);
    },
    filters(obj) {
      let val = {};
      if (obj.dateTwo == "") {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          species_id: obj.species != null ? obj.species.id : "",
          gender_id: obj.gender != null ? obj.gender.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateOne ? moment(obj.dateOne).format("YYYY-MM-DD") : "",
        };
      } else {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          species_id: obj.species != null ? obj.species.id : "",
          gender_id: obj.gender != null ? obj.gender.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateTwo ? moment(obj.dateTwo).format("YYYY-MM-DD") : "",
        };
      }
      this.filterAnimal(val);
    },
    moment(date) {
      return moment(date)
        .tz("Asia/Bangkok")
        .format("DD-MM-YYYY  h:mm:ss");
    },
    setCorporation(id) {
      this.corporation.forEach((element) => {
        if (element.id == id) {
          this.data.corporation.id = element;
        }
      });

      // console.log(this.data.corporation_id)
    },
    async setCodeFromDirection() {
      // this.data.code = this.data.code.substring(2);
      if (this.data.direction_info.direction.id == this.existsDirectionId) {
        this.data.code = this.existsCode;
      } else {
        this.data.code = await this.genCodeHospital(
          this.data.direction_info.direction.id
        );
      }
      // if (this.data.direction_info.direction.id <= 9) {
      //   this.data.code =
      //     "0" + this.data.direction_info.direction.id + this.data.code;
      // } else {
      //   this.data.code =
      //     "" + this.data.direction_info.direction.id + this.data.code;
      // }
    },
    async goHistoryPage(data) {
      if (data == null) {
        this.$store.state.isLoading = false;
        this.$router.push({ name: "history" });
      } else {
        if (
          this.data.name === "" ||
          this.isInvalid ||
          !this.checkMorning ||
          !this.checkAfternoon ||
          !this.checkEvening ||
          this.isInvalidCorp ||
          !(
            this.checkMorningInput ||
            this.checkAfternoonInput ||
            this.checkEveningInput
          ) ||
          this.contact.length <= 0
        ) {
          // console.log(this.data.name, this.isInvalid, this.checkMorning, this.checkAfternoon, this.isInvalidCorp, this.contact.length, this.checkMorningInput, this.checkAfternoonInput)
          this.$swal.fire("Please fill");
          this.$store.state.isLoading = false;
        } else {
          const newData = {
            id: data.id,
            name: data.name,
            branch: data.branch,
            code: data.code,
            phone: data.phone,
            office_phone: data.office_phone,
            address: data.address,
            road: data.road,
            district_code: this.objDistricts[data.districts_name]
              ? this.objDistricts[data.districts_name]
              : "",
            sub_district_code: this.objSubDistricts[data.sub_districts_name]
              ? this.objSubDistricts[data.sub_districts_name]
              : "",
            province_code: this.objProvinces[data.province_name]
              ? this.objProvinces[data.province_name]
              : "",
            postal_code: data.postal_code,
            email: data.email,
            fax: data.fax,
            line_id: data.line_id,
            note: data.note,
            contact_types: this.changeContactToId(this.contact),
            tax_id: data.tax_id,
            billing_name: data.billing_name,
            credit_type_id: data.credit_type != null ? data.credit_type.id : "",
            customer_type_id:
              data.customer_type != null ? data.customer_type.id : "",
            direction_id:
              data.direction_info.direction != null
                ? data.direction_info.direction.id
                : "",
            morning:
              data.direction_info.morning && this.checkMorningInput
                ? // ? moment(data.direction_info.morning).format("HH:mm:ss")
                  data.direction_info.morning
                : null,
            afternoon:
              data.direction_info.afternoon && this.checkAfternoonInput
                ? // ? moment(data.direction_info.afternoon).format("HH:mm:ss")
                  data.direction_info.afternoon
                : null,
            evening:
              data.direction_info.evening && this.checkEveningInput
                ? // ? moment(data.direction_info.evening).format("HH:mm:ss")
                  data.direction_info.evening
                : null,
            urgency_hospital_type_id:
              data.urgency_hospital_type != null
                ? data.urgency_hospital_type.id
                : "",
            // corporation_id: data.corporation
            //   ? data.corporation.id
            //   : "",
            addresses: data.addresses,
            corporation: data.corporation,
            phones: data.phones,
            // lineIds: data.lineIds,
            faxs: data.faxs,
            emails: data.emails,
            contactTypeFileSelected: this.contactTypeFileSelected,
          };

          await this.updateData(newData);
          await this.filters({
            hospital: { id: data.id },
          });

          this.$nextTick(() => {
            let corporation = data.corporation ? data.corporation.id : null;
            this.setCorporation(corporation);
          });
          // console.log(this.data.corporation_id)
          // await this.setCorporation(this.data.corporation_id);
          // await this.setData(this.data.id);
          const addingCustomer = false;
          const addingAnimal = false;
          this.setAdding({ addingCustomer, addingAnimal });
          // this.setAnimalList();

          // await this.setContactType(this.data.contact_types);
          this.$store.state.isLoading = false;
          this.$store.state.isEditing = false;
          Swal.fire(" สำเร็จ", "บันทึกข้อมูลสำเร็จ", "success");
          // console.log(this.contact)
          // this.$router.push({ name: "history-customer-adding" });
        }
      }
    },
    setOptions() {
      const arrayProvinces = [];
      const codeProvinces = [];
      const arrayDistricts = [];
      const codeDistricts = [];
      const arraySubDistricts = [];
      const codeSubDistricts = [];
      const arrayContactTypes = [];
      const codeContactTypes = [];
      this.provinces.forEach((element) => {
        arrayProvinces.push(element.name);
        codeProvinces[element.name] = element.code;
        this.lstProvinces = arrayProvinces;
        this.objProvinces = codeProvinces;
      });
      this.districts.forEach((element) => {
        arrayDistricts.push(element.name);
        codeDistricts[element.name] = element.code;
        this.lstDistricts = arrayDistricts;
        this.objDistricts = codeDistricts;
      });
      this.subDistricts.forEach((element) => {
        arraySubDistricts.push(element.name);
        codeSubDistricts[element.name] = element.code;
        this.lstSubDistricts = arraySubDistricts;
        this.objSubDistricts = codeSubDistricts;
      });
      this.contactTypes.forEach((element) => {
        arrayContactTypes.push(element.type_name);
        codeContactTypes[element.type_name] = element.id;
        this.lstContactTypes = arrayContactTypes;
        this.objContactTypes = codeContactTypes;
      });
    },
    setContactType(contact_types) {
      const array = [];
      // console.log(contact_types)
      contact_types.forEach((element) => {
        array.push(element.type_name);
      });
      // this.contact = array;
    },
    changeContactToId(lst) {
      const array = [];
      lst.forEach((element, index) => {
        array.push(this.objContactTypes[lst[index]]);
      });
      return array;
    },
    resetDistrict() {
      this.data.district_code = "เลือกเขต/อำเภอ";
      this.data.districts_name = "เลือกเขต/อำเภอ";
    },
    resetSubDistrict() {
      this.data.sub_district_code = "เลือกแขวง/ตำบล";
      this.data.sub_districts_name = "เลือกแขวง/ตำบล";
    },
    async changeAndGo(data) {
      this.confirm = true;
      this.$store.state.isLoading = true;
      if (
        !this.data.name ||
        !this.data.billing_name ||
        !this.data.corporation ||
        !this.data.direction_info.direction ||
        this.data.addresses.length <= 0 ||
        this.data.phones.length <= 0
      ) {
        this.$swal.fire("invalid input.");
        this.$store.state.isLoading = false;
      } else {
        if (!this.checkMorning || !this.checkAfternoon || !this.checkEvening) {
          await this.goHistoryPage(data);
        } else {
          await this.goHistoryPage(data);
        }
      }
    },
    addAddress() {
      if (
        this.addressInput === "" ||
        this.provinceInput === "" ||
        this.districtInput === "" ||
        this.subDistrictInput === "" ||
        this.postCodeInput === ""
      ) {
        this.$swal.fire("invalid input.");
      } else {
        let provinceCode = this.objProvinces[this.provinceInput];
        let districtTitle = provinceCode === 10 ? "เขต" : "อำเภอ";
        let subdistrictTitle = provinceCode === 10 ? "แขวง" : "ตำบล";
        let provinceTitle = provinceCode === 10 ? "" : "จังหวัด";
        this.data.addresses.push({
          branch: this.addressInput,
          province: provinceTitle + this.provinceInput,
          provinceCode: this.objProvinces[this.provinceInput],
          district: districtTitle + this.districtInput,
          districtCode: this.objDistricts[this.districtInput],
          subDistrict: subdistrictTitle + this.subDistrictInput,
          subDistrictCode: this.objSubDistricts[this.subDistrictInput],
          postalCode: this.postCodeInput,
          default: this.data.addresses.length <= 0,
        });
        this.addressInput = "";
        this.provinceInput = "";
        this.districtInput = "";
        this.subDistrictInput = "";
        this.postCodeInput = "";
      }
    },
    delAddress(index) {
      let delAdd = this.data.addresses[index];
      this.data.addresses.splice(index, 1);
      if (delAdd.default) {
        if (this.data.addresses.length > 0) {
          this.data.addresses[0].default = true;
        }
      }
    },
    addPhone() {
      if (this.phoneInput === "") {
        this.$swal.fire("invalid input.");
      } else {
        this.data.phones.push({
          value: this.phoneInput,
          default: this.data.phones.length <= 0,
        });
        this.phoneInput = "";
      }
    },
    delPhone(index) {
      let delPhoneSelected = this.data.phones[index];
      this.data.phones.splice(index, 1);
      if (delPhoneSelected.default) {
        if (this.data.phones.length > 0) {
          this.data.phones[0].default = true;
        }
      }
    },
    // addLineId() {
    //     if (this.lineIdInput === "") {
    //         alert("invalid input.");
    //     } else {
    //         this.data.lineIds.push(this.lineIdInput);
    //         this.lineIdInput = "";
    //     }
    // },
    async goHistoryAnimalAdding() {
      const addingCustomer = false;
      const addingAnimal = false;
      this.setAdding({ addingCustomer, addingAnimal });
      let routeData = this.$router.resolve({ name: "history-animal-adding" });
      window.open(routeData.href, "_blank");
    },
    addFax() {
      if (this.faxInput === "") {
        this.$swal.fire("invalid input.");
      } else {
        this.data.faxs.push({
          value: this.faxInput,
          default: this.data.faxs.length <= 0,
        });
        this.faxInput = "";
      }
    },
    addEmail() {
      if (this.emailInput === "") {
        this.$swal.fire("invalid input.");
      } else {
        this.data.emails.push({
          value: this.emailInput,
          default: this.data.emails.length <= 0,
        });
        this.emailInput = "";
      }
    },
    delLine(index) {
      this.data.lineIds.splice(index, 1);
    },
    delFax(index) {
      let delFaxSelected = this.data.faxs[index];
      this.data.faxs.splice(index, 1);

      if (delFaxSelected.default) {
        if (this.data.faxs.length > 0) {
          this.data.faxs[0].default = true;
        }
      }
    },
    delEmail(index) {
      let delEmailSelected = this.data.emails[index];
      this.data.emails.splice(index, 1);

      if (delEmailSelected.default) {
        if (this.data.emails.length > 0) {
          this.data.emails[0].default = true;
        }
      }
    },
    checkDisableSendGroup(val) {
      switch (val) {
        case "phone":
          return this.data.phones.length <= 0;
        case "line_id":
          return false;
        // return this.data.lineIds.length <= 0;
        case "fax":
          return this.data.faxs.length <= 0;
        case "email":
          return this.data.emails.length <= 0;
      }
    },
    async goAdd() {
      if (this.$store.state.isEditing) {
        let confirmRoute = await Swal.fire({
          title: "คุณกำลังออกจากหน้าที่กำลังแก้ไขข้อมูลและยังไม่ได้ถูกบันทึก",
          text:
            "หากคุณออกจากหน้านี้ ข้อมูลที่คุณแก้ไขจะไม่ถูกเปลี่ยนแปลง คุณต้องการออกจากหน้านี้ใช่หรือไม่",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ออกจากหน้านี้",
          cancelButtonText: "อยู่ต่อ",
        });

        if (!confirmRoute.value) {
          return;
        } else {
          this.$store.state.isEditing = false;
        }
      }
      const addingCustomer = true;
      const addingAnimal = true;
      await this.setAnimalData(null);
      await this.setCustomerData(this.data.id);
      await this.setAdding({ addingAnimal });
      let routeData = this.$router.resolve({
        name: "history-animal-adding",
        // params: { hospital_name: this.data.name, hospital_id: this.data.id },
        query: { hospital_name: this.data.name, hospital_id: this.data.id },
      });
      window.open(routeData.href, "_blank");
    },
    setAnimalList() {
      if (this.data.id !== "") {
        const res = {
          page_no: "1",
          direction_id: "",
          hospital_id: this.data.id,
          species_id: "",
          gender_id: "",
          owner_name: "",
          pet_name: "",
          hn: "",
          start_date: "",
          end_date: "",
        };
        // var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
        // this.filter.dateOne = today;
        // this.filterAnimal(res);
        this.$nextTick((val) => {
          this.filterAnimal(res);
        });
      }
    },
  },
  filters: {
    convertContactTypeName(val) {
      switch (val) {
        case "phone":
          return "โทรศัพท์";
        case "line_id":
          return "LINE";
        case "fax":
          return "FAX";
        case "email":
          return "E-mail";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#history-adding {
  width: 92vw;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.topic {
  text-align: left;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 20px;
  color: #2f3438;
}
.left {
  text-align: left;
}

.invalidText {
  border: 0.5px solid red;
}

.star {
  color: red;
  padding-left: 5px;
  width: 12px;
  height: auto;
  padding-top: 4px;
  vertical-align: top;
}

.form-group-wrapper {
  border: 1px solid #999999;

  &.invalidText {
    border: 0.5px solid red;
  }
}

.add-btn {
  /*border-radius: 50%;*/
  background-color: rgba(4, 169, 12, 0.76);
  color: white;
  border: none;
}

.invalid-time {
  background: #ff6a6a;
}
</style>
